"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DecimalPgHandler", {
    enumerable: true,
    get: function() {
        return DecimalPgHandler;
    }
});
const _decimalgeneralhandler = require("./decimal.general.handler");
const _genericpg = require("~/db/field-handler/handlers/generic.pg");
let DecimalPgHandler = class DecimalPgHandler extends _genericpg.GenericPgFieldHandler {
    constructor(...args){
        super(...args), this.decimalGeneralHandler = new _decimalgeneralhandler.DecimalGeneralHandler(), this.select = this.decimalGeneralHandler.select, this.filter = this.decimalGeneralHandler.filter, this.verifyFilter = this.decimalGeneralHandler.verifyFilter, this.parseUserInput = this.decimalGeneralHandler.parseUserInput, this.parseDbValue = this.decimalGeneralHandler.parseDbValue, this.filterBlank = this.decimalGeneralHandler.filterBlank, this.filterNotblank = this.decimalGeneralHandler.filterNotblank, this.filterNeq = this.decimalGeneralHandler.filterNeq;
    }
};
